function _typeof2(obj) { "@babel/helpers - typeof"; return _typeof2 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof2(obj); }

function _typeof(obj) {
  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
    _typeof = function _typeof(obj) {
      return _typeof2(obj);
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : _typeof2(obj);
    };
  }

  return _typeof(obj);
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}
/*=============================================================================
 * Copyright (C) 2017 Stephen F. Norledge and Alces Flight Ltd.
 *
 * This file is part of Flight Launch.
 *
 * All rights reserved, see LICENSE.txt.
 *===========================================================================*/


import React from 'react';
import PropTypes from 'prop-types';
import { Button, ButtonToolbar } from 'reactstrap';
import invariant from 'invariant';
import styled, { css } from 'styled-components';
import withConfirmation from './withConfirmation';
var ConfirmableButton = withConfirmation()(function (_ref) {
  var children = _ref.children,
      confirmationPopover = _ref.confirmationPopover,
      showingConfirmation = _ref.showingConfirmation,
      submitting = _ref.submitting,
      props = _objectWithoutProperties(_ref, ["children", "confirmationPopover", "showingConfirmation", "submitting"]);

  return /*#__PURE__*/React.createElement(Button, props, children, confirmationPopover);
});
var Contents = styled.div.withConfig({
  displayName: "MultiPageForm__Contents",
  componentId: "sc-4cre63-0"
})(["", " ", ""], function (props) {
  return props.height != null && css(["height:", ";"], props.height);
}, function (props) {
  return props.minHeight != null && css(["min-height:", ";"], props.minHeight);
});

var MultiPageForm = /*#__PURE__*/function (_React$Component) {
  _inherits(MultiPageForm, _React$Component);

  function MultiPageForm() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, MultiPageForm);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(MultiPageForm)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "handleShowNextPage", function () {
      if (_this.props.onShowNextPage) {
        _this.props.onShowNextPage();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleShowPreviousPage", function () {
      if (_this.props.onShowPreviousPage) {
        _this.props.onShowPreviousPage();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "renderButtons", function () {
      return /*#__PURE__*/React.createElement(ButtonToolbar, null, /*#__PURE__*/React.createElement(Button, {
        disabled: _this.props.currentPageIndex === 0,
        key: "previousPage",
        onClick: _this.handleShowPreviousPage
      }, "Previous"), _this.renderSubmitOrNextButton(), _this.renderCancelButton());
    });

    return _this;
  }

  _createClass(MultiPageForm, [{
    key: "requiresConfirmation",
    value: function requiresConfirmation() {
      return this.props.onConfirm != null;
    }
  }, {
    key: "renderCancelButton",
    value: function renderCancelButton() {
      if (this.props.onCancel) {
        return /*#__PURE__*/React.createElement(Button, {
          className: "ml-auto",
          key: "cancelButton",
          onClick: this.props.onCancel
        }, "Cancel");
      }

      return null;
    }
  }, {
    key: "renderSubmitOrNextButton",
    value: function renderSubmitOrNextButton() {
      var currentPage = this.props.pages[this.props.currentPageIndex];
      var disabled = currentPage.valid != null ? !currentPage.valid() : false;
      var submitting = this.props.submitting;
      var commonProps = {
        className: "ml-1",
        color: 'success',
        disabled: disabled || submitting,
        type: 'submit'
      };

      if (this.props.currentPageIndex === this.props.pages.length - 1) {
        var ButtonComponent;
        var extraProps;

        if (this.requiresConfirmation()) {
          ButtonComponent = ConfirmableButton;
          extraProps = {
            confirmButtonText: this.props.confirmButtonText,
            confirmText: this.props.confirmText,
            id: "".concat(this.props.id, "-button"),
            onConfirm: this.props.onConfirm,
            placement: this.props.confirmationPlacement
          };
        } else {
          ButtonComponent = Button;
          extraProps = {};
        }

        return /*#__PURE__*/React.createElement(ButtonComponent, _extends({
          key: "submitForm"
        }, commonProps, extraProps), submitting ? this.props.submittingButtonContent : this.props.submitButtonContent);
      }

      return /*#__PURE__*/React.createElement(Button, _extends({
        key: "nextPage",
        onClick: this.handleShowNextPage
      }, commonProps), "Next");
    }
  }, {
    key: "renderPage",
    value: function renderPage() {
      var currentPageIndex = this.props.currentPageIndex;
      var page = this.props.pages[currentPageIndex];
      invariant(page, 'Page %s has not been configured', currentPageIndex);
      return page.render();
    }
  }, {
    key: "render",
    value: function render() {
      var onSubmit;

      if (this.requiresConfirmation()) {
        onSubmit = function onSubmit(event) {
          event.preventDefault();
        };
      } else {
        onSubmit = this.props.handleSubmit;
      }

      return /*#__PURE__*/React.createElement("form", {
        onSubmit: onSubmit
      }, /*#__PURE__*/React.createElement(Contents, {
        height: this.props.height,
        minHeight: this.props.minHeight
      }, this.renderPage()), this.renderButtons());
    }
  }]);

  return MultiPageForm;
}(React.Component);

_defineProperty(MultiPageForm, "propTypes", {
  confirmButtonText: PropTypes.string,
  confirmText: PropTypes.node,
  confirmationPlacement: PropTypes.string,
  currentPageIndex: PropTypes.number,
  handleSubmit: PropTypes.func.isRequired,
  height: PropTypes.string,
  id: PropTypes.string.isRequired,
  minHeight: PropTypes.string,
  onCancel: PropTypes.func,
  onConfirm: PropTypes.func,
  onShowNextPage: PropTypes.func,
  onShowPreviousPage: PropTypes.func,
  pages: PropTypes.arrayOf(PropTypes.shape({
    render: PropTypes.func.isRequired,
    valid: PropTypes.func
  }).isRequired).isRequired,
  submitButtonContent: PropTypes.node.isRequired,
  submitting: PropTypes.bool,
  submittingButtonContent: PropTypes.node.isRequired
});

_defineProperty(MultiPageForm, "defaultProps", {
  currentPageIndex: 0,
  submittingButtonContent: "Submitting"
});

export default MultiPageForm;